export default {
  path: '/alarms/events',
  name: 'AlarmEvents',
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/AlarmEventsView.vue')
}
